import { StartOverButton } from "../partials/buttons";

export default {
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "25px",
    "& .start-over-button": {
      ...StartOverButton
    },
    "&.toRight": {
      justifyContent: "flex-end"
    }
  }
};
